export const getReservationSelection = (seats, ticketTypes) => {
  const groups = new Map();
  for (const seat of seats) {
    const multiType = ticketTypes.some(
      (type) => Number(type.category) === Number(seat.categoryId) && type.ticketTypes.length > 0
    );
    const ticketType = multiType ? String(seat.typeId) : undefined;
    const key = JSON.stringify([seat.id, ticketType]);
    const group = groups.get(key) || { label: seat.id, ...(multiType ? { ticketType } : {}), amount: 0 };
    group.amount += 1;
    groups.set(key, group);
  }
  return [...groups.values()];
};

export const sortReservationItems = (seats) =>
  seats
    .map(({ id, typeId }) => ({ id, typeId }))
    .sort((a, b) => a.id.localeCompare(b.id) || String(a.typeId).localeCompare(String(b.typeId)));

// This function is serialized and executed inside the Seats.io iframe.
export const createReservationSelectability = (seats) =>
  // eslint-disable-next-line no-new-func
  new Function(
    'obj',
    `
    const inRes = ${JSON.stringify(seats.map((seat) => seat.id))};
    if (obj.category.key === 'default_category' || !obj.forSale) return false;
    if (obj.objectType === 'GeneralAdmissionArea') {
      return obj.areaType ? obj.areaType === 'generalAdmission' : !obj.bookAsAWhole && !obj.variableOccupancy;
    }
    return obj.status === 'free' || inRes.includes(obj.id);
  `
  );
